import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const SEARCH_QUERY = gql`
  query getDeadlineContracts($where: DeadlineContractWhereInput, $limit: Int, $offset: Int) {
    deadlineContracts(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-deadline-contract-outlined-select',
  templateUrl: './fc-deadline-contract-outlined-select.component.html',
})
export class FcDeadlineContractOutlinedSelectComponent {

  @Input() public label: string;
  @Input() public required: boolean;
  @Input() public control: FormControl;

  constructor(
    public apollo: Apollo,
  ) {}

  public searchDeadlineContracts(searchTerm: string, limit: number, offset: number): Observable<any[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            archived: false,
            name_contains: searchTerm
          },
          limit: limit,
          offset: offset
        }
      })
      .pipe(
        map(({ data }) => {
          return data['deadlineContracts']['items'];
        })
      );
  }
}
